/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tab/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaStep from 'DesignSystem/TysiaStep/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tab({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActionTabs/Content/Tab"
  
}) {
let selectedIndexValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'index',
})
let actionExecutionItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'action_execution_item',
path: 'index',
})
let aggregateData = fromAggregate.equals(selectedIndexValueData, actionExecutionItemIndexValueData)
let selectedStatusValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'status',
format: fromHelpers.isCompletedOrSkipped,
})
let actionExecutionItemIndexValueData1 = fromData.useDataFormat({ viewPath,
context: 'action_execution_item',
path: 'index',
format: fromHelpers.addOne,
})
let actionExecutionActionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'action_execution',
path: 'action_type',
format: fromHelpers.getTabName,
})
let actionExecutionItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'action_execution_item',
path: 'isLast',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Tab.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaStep
  viewPath={`${viewPath}/TysiaStep`}
 data="selected.index"
 data="action_execution_item.index"
 aggregate="/Data/aggregate.js equals"
 selected={aggregateData}
 data="selected.status"
 format="./helpers.js isCompletedOrSkipped"
 complete={selectedStatusValueData}
 data="action_execution_item.index"
 format="./helpers.js addOne"
 step={actionExecutionItemIndexValueData1}
 data="action_execution.action_type"
 format="helpers.js getTabName"
 text={actionExecutionActionTypeValueData}
/>
<fromFlow.When is={!actionExecutionItemIsLastValueData}>
<div
  data-testid="Tab.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-mwf': dtColorsNeutral300,'--ml-2-mwf': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-mwf': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}